import { HelpLink } from 'elements/link/HelpLink'
import { useTranslate } from 'react-admin'

const CostingTitle = ({ record, translate, style }) => {
  return (
    <span style={style}>
      {translate('My Costing Schemes')} {record ? `"${record.title}"` : ''}
    </span>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate(
        "You can include all of your project costs within OpenSolar, which allows you to track profitability and use 'cost-plus' pricing schemes."
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/13277732722703-How-to-create-a-cost-scheme" />
    </span>
  )
}

export default {
  list: { lazy: () => import('./Costings'), component: 'CostingList' },
  edit: { lazy: () => import('./Costings'), component: 'CostingEdit' },
  create: { lazy: () => import('./Costings'), component: 'CostingCreate' },
  options: {
    create: {
      title: 'Create Costing Scheme',
      subtitle: null,
      breadCrumb: 'Create Costing Scheme',
    },
    list: {
      title: 'Costing Schemes',
      subtitle: <Subtitle />,
      breadCrumb: 'Costing Schemes',
    },
    edit: {
      title: <CostingTitle />,
      subtitle: null,
      breadCrumb: 'Edit Costing Scheme',
    },
  },
}
